import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, ToggleButtonGroup, ToggleButton, Card, CardContent, Alert, AlertTitle, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import axios from "../../components/axios";
import CustomDatePicker from '../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import PieChartNoTable from '../components/Chart/PieChartNoTable';
import TextFieldCommon from '../components/Form/TextFieldCommon';


const TestAutomationPage = () => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = useState('and');
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [search, setSearch] = useState("");
  const [noDataMessage, setNoDataMessage] = useState('');
  const threshold = 1000;
  const exportURL = '/peloton/v1/automation/test-report-csv';
  const shareAPI = 'release-share-link';
  const [fullQuery, setFullQuery] = useState('');
  const [deleteItemID, setDeleteItemID] = useState('');
  const [openSummary, setOpenSummary] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [series, setSeries] = useState([]);
  const [total, setTotal] = useState(0);
  const [pass, setPass] = useState(0);
  const [fail, setFail] = useState(0);
  const [skip, setSkip] = useState(0);
  const isOTA = '0';
  const showShare = true;
  const showSummary = true;

const handleClose = () => {
    setOpenSummary(false);
  };

  function searchChange(e) {
    setSearch(e.target.value);
  }

  const [open, setOpen] = useState(false);
  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleToggle = {
    marginTop: "10px",
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignment(newAlignment);
  };

  const handleDownload = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid })
      console.log(uuid)
      axios.post("/peloton/v1/automation/test-report-file", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleRedirect = (uuid) => {
    console.log(uuid)
      var input_data = JSON.stringify({ item_uuid: uuid });
      axios.post("/peloton/v1/automation/test-report-pages", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(process.env.REACT_APP_API_URL+response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleQueryData = () => {
    if (search === "" && state[0].startDate === null && state[0].endDate === null ){
      alert("Please select query date range or keyword!");
    }else{
      setRows([]);
      setTotal(0);
      setPass(0);
      setFail(0);
      setSkip(0);
      setSeries([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }

      var input_data = JSON.stringify({ query: search, start_date: startDateStr, end_date: endDateStr, condition: alignment })
      setFullQuery(input_data);
      axios.post("/peloton/v1/automation/test-report",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null && response.data.data.length > 0){
            if (response.data.data.length >threshold){
                setshowAlert(true);
                setNoDataMessage('More than 1000 rows, please click "Export Data" to download file')
            }else{
              setRows(response.data.data);
              setshowAlert(false);
            }
            setTotal(response.data.total_count);
            setPass(response.data.pass_count);
            setFail(response.data.fail_count);
            setSkip(response.data.skip_count);
            setSeries([response.data.pass_count, response.data.fail_count, response.data.skip_count]);
            setshowTable(true);
          }else{
            setNoDataMessage('No data in this condition.')
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(err => {
        if (err.message === 'timeout of 3000ms exceeded'){
          setshowAlert(true);
          setNoDataMessage('Too many rows, please click "Export Data" to download file')
          setshowTable(true);
        }else{
          if (!err.response){
            alert(err)
          }else{
            if (err.response.status === 401){
              navigate("/");
            }else{
              alert(err.response.data.message);
            }
          }
        }
      })
    }
  };

  const handleSummary = () => {
    setOpenSummary(true)
  };

  const handleClear = () => {
    setSearch('');
  };

const columns = [
  { id: 'serial_number', label: 'Serial Number', align: 'left' },
  { id: 'affernet', align: 'center', label: 'Affernet'},
  { id: 'dm', align: 'center', label: 'DM'},
  { id: 'start_time', align: 'center', label: 'Start Time'},
  { id: 'end_time', align: 'center', label: 'End Time'},
  { id: 'OTA_service', align: 'center', label: 'OTA service'},
  { id: 'fw_updater', align: 'center', label: 'FW Updater'},
  { id: 'home_app', align: 'center', label: 'Home App'},
  { id: 'platform', align: 'center', label: 'platform'},
  { id: 'suite_name', align: 'center', label: 'Suite Name'},
  { id: 'system_image', align: 'center', label: 'System Image'},
  { id: 'system_image_type', align: 'center', label: 'Image Type'},
  { id: 'total', align: 'center', label: 'Total'},
  { id: 'pass', align: 'center', label: 'Pass'},
  { id: 'fail', align: 'center', label: 'Fail'},
  { id: 'skip', align: 'center', label: 'Skip'},
  { id: 'action', label: 'Download', align: 'center', action: true},
  { id: 'view', label: 'Show', align: 'center', view: true },
  { id: 'ignore', label: 'Ignore', align: 'center', ignore: true },
];

const handleDeleteClose = () => {
  setShowDialogDelete(false);
};

  const deleteTestRecord = () => {
    var input_data = JSON.stringify({ item_uuid: deleteItemID });
      axios.post("/peloton/v1/automation/remove-test-record", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          handleQueryData()
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
    })
    .finally(() => {
      setDeleteItemID('');
      setShowDialogDelete(false);
    });
  }

  const handleDelete = (row) => {
    console.log(row.uuid);
    setDeleteItemID(row.uuid);
    setShowDialogDelete(true);
  };

  return (
    <MainCard title="Text Filter">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Text Filter
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={3}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={4}>
            <TextFieldCommon search={search} searchChange={searchChange} handleClear={handleClear}/>
        </Grid>
        <Grid item xs={1}>
          <ToggleButtonGroup
            color="error"
            size="small"
            value={alignment}
            exclusive
            onChange={handleChange}
            style={styleToggle}
          >
            <ToggleButton value="and" color="info">AND</ToggleButton>
            <ToggleButton value="or" color="info">OR</ToggleButton>
          </ToggleButtonGroup>
          <Dialog open={openSummary} onClose={handleClose} fullWidth>
            <PieChartNoTable series={series} total={total} pass={pass} fail={fail} skip={skip} fullQuery={fullQuery} isShareable={true} shareAPI={shareAPI}/>
          </Dialog>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<StickyHeadTwoButtonTable rows={rows} columns={columns} handleDownload={handleDownload} handleRedirect={handleRedirect} exportURL={exportURL} fullQuery={fullQuery} showSummary={showSummary} handleSummary={handleSummary} isOTA={isOTA} showShare={showShare} shareAPI={shareAPI} handleDelete={handleDelete}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}

      <Dialog open={showDialogDelete} onClose={handleDeleteClose} fullWidth>
        <DialogTitle id="alert-dialog-title">
          {"Confirm delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to ignore this test record ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose}>Cancel</Button>
          <Button onClick={deleteTestRecord} autoFocus>
            Ignore
          </Button>
        </DialogActions>
      </Dialog>
    </MainCard>)
};

export default TestAutomationPage;
